<template>
  <div class="progress-lists">
    <QList>
      <QItem class="progress-item" v-if="businessDetails">
        <QItemSection side class="side-icon">
          <QIcon color="primary" size="18px">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M18 4H15V2C15 0.897 14.103 0 13 0H7C5.897 0 5 0.897 5 2V4H2C0.897 4 0 4.897 0 6V17C0 18.103 0.897 19 2 19H18C19.103 19 20 18.103 20 17V6C20 4.897 19.103 4 18 4ZM13 2V4H7V2H13ZM18 6V9H2V6H18ZM2 17V11H8V13H12V11H18L18.001 17H2Z"
                fill="currentColor"
              />
            </svg>
          </QIcon>
        </QItemSection>
        <QItemSection> Business details & credit application</QItemSection>
        <QItemSection side>
          <CalculatorButton
            :class="['progress-item-btn', ...(getProgressText(businessDetails) === 'Completed' && ['done'])].join(' ')"
            color="secondary"
            :hasChevronIcon="getProgressText(businessDetails) !== 'Completed'"
            rounded
            :label="getProgressText(businessDetails)"
          />
        </QItemSection>
      </QItem>
      <QItem class="progress-item">
        <QItemSection side class="side-icon">
          <QIcon color="primary" size="18px">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M18.29 4.29008L14 8.58008L12.7 7.29008L11.29 8.71008L13.99 11.4101L19.71 5.71008L18.29 4.29008ZM2 4.00008C1.98768 4.52874 2.08273 5.0544 2.27939 5.54527C2.47605 6.03614 2.77024 6.48202 3.14415 6.85593C3.51807 7.22985 3.96395 7.52403 4.45482 7.72069C4.94569 7.91735 5.47134 8.0124 6 8.00008C6.52866 8.0124 7.05431 7.91735 7.54518 7.72069C8.03605 7.52403 8.48193 7.22985 8.85585 6.85593C9.22976 6.48202 9.52395 6.03614 9.72061 5.54527C9.91727 5.0544 10.0123 4.52874 10 4.00008C10.0123 3.47143 9.91727 2.94577 9.72061 2.4549C9.52395 1.96403 9.22976 1.51815 8.85585 1.14424C8.48193 0.770319 8.03605 0.476134 7.54518 0.279475C7.05431 0.0828155 6.52866 -0.0122312 6 8.40162e-05C5.47134 -0.0122312 4.94569 0.0828155 4.45482 0.279475C3.96395 0.476134 3.51807 0.770319 3.14415 1.14424C2.77024 1.51815 2.47605 1.96403 2.27939 2.4549C2.08273 2.94577 1.98768 3.47143 2 4.00008ZM8 4.00008C8.01286 4.26613 7.96993 4.53193 7.87398 4.78041C7.77802 5.02888 7.63115 5.25454 7.4428 5.44289C7.25446 5.63123 7.0288 5.7781 6.78032 5.87406C6.53185 5.97002 6.26605 6.01295 6 6.00008C5.73395 6.01295 5.46815 5.97002 5.21968 5.87406C4.9712 5.7781 4.74554 5.63123 4.5572 5.44289C4.36885 5.25454 4.22198 5.02888 4.12602 4.78041C4.03007 4.53193 3.98714 4.26613 4 4.00008C3.98714 3.73403 4.03007 3.46824 4.12602 3.21976C4.22198 2.97128 4.36885 2.74563 4.5572 2.55728C4.74554 2.36894 4.9712 2.22207 5.21968 2.12611C5.46815 2.03015 5.73395 1.98722 6 2.00008C6.26605 1.98722 6.53185 2.03015 6.78032 2.12611C7.0288 2.22207 7.25446 2.36894 7.4428 2.55728C7.63115 2.74563 7.77802 2.97128 7.87398 3.21976C7.96993 3.46824 8.01286 3.73403 8 4.00008ZM2 14.0001C2 13.2044 2.31607 12.4414 2.87868 11.8788C3.44129 11.3162 4.20435 11.0001 5 11.0001H7C7.79565 11.0001 8.55871 11.3162 9.12132 11.8788C9.68393 12.4414 10 13.2044 10 14.0001V15.0001H12V14.0001C12 13.3435 11.8707 12.6933 11.6194 12.0867C11.3681 11.48 10.9998 10.9288 10.5355 10.4646C10.0712 10.0003 9.52004 9.63196 8.91342 9.38069C8.30679 9.12941 7.65661 9.00008 7 9.00008H5C3.67392 9.00008 2.40215 9.52687 1.46447 10.4646C0.526784 11.4022 0 12.674 0 14.0001V15.0001H2V14.0001Z"
                fill="currentColor"
              />
            </svg>
          </QIcon>
        </QItemSection>
        <QItemSection> ID check & application review </QItemSection>
        <img
          src="/assets/icons/small-info.svg"
          alt="Identification verification and credit application are required as part of this step."
          title="Identification verification and credit application are required as part of this step."
          :style="convertColourComputed ? convertColourComputed : ''"
          style="cursor: pointer; vertical-align: middle; margin: 0 -5px 0 0"
          @click="openDialog()"
        />
        <QItemSection side>
          <CalculatorButton
            :class="['progress-item-btn', ...(getProgressText(approvals) === 'Completed' && ['done'])].join(' ')"
            color="secondary"
            :hasChevronIcon="getProgressText(approvals) !== 'Completed'"
            rounded
            :label="getProgressText(approvals)"
          />
        </QItemSection>
      </QItem>
      <QItem class="progress-item" v-if="reviewSignContract">
        <QItemSection side class="side-icon">
          <QIcon color="primary" size="18px">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M16.707 3.82598L13.172 0.292977C12.9856 0.106292 12.733 0.000888997 12.4692 -0.000235058C12.2055 -0.00135911 11.9519 0.101887 11.764 0.286977L3.096 8.81998C2.96089 8.95371 2.86626 9.12286 2.823 9.30798L1.799 13.745L0 16H2.828L3.97 14.871L7.558 14.043C7.738 14.001 7.903 13.91 8.035 13.781L16.702 5.24598C16.7961 5.15335 16.8708 5.04301 16.922 4.92133C16.9732 4.79964 16.9998 4.66903 17.0003 4.53702C17.0008 4.40501 16.9751 4.27421 16.9247 4.15217C16.8744 4.03013 16.8004 3.91927 16.707 3.82598ZM7.338 11.659L5.217 9.53898L12.46 2.40798L14.58 4.52798L7.338 11.659ZM0 18H16V20H0V18Z"
                fill="currentColor"
              />
            </svg>
          </QIcon>
        </QItemSection>
        <QItemSection> Review & sign lease documents</QItemSection>
        <QItemSection side>
          <CalculatorButton
            :class="['progress-item-btn', ...(getProgressText(reviewSignContract) === 'Completed' && ['done'])].join(' ')"
            color="secondary"
            :hasChevronIcon="getProgressText(reviewSignContract) !== 'Completed'"
            rounded
            :label="getProgressText(reviewSignContract)"
          />
        </QItemSection>
      </QItem>
    </QList>
    <QDialog v-model="showDocusign" full-width full-height>
      <QCard>
        <iframe :src="docusignUrl" style="width: 100%; height: calc(100% - 60px)" v-if="docusignUrl"></iframe>
        <div v-else class="flex justify-center items-center q-pa-md" style="width: 100%; height: calc(100% - 60px)">
          <QSpinner size="md" color="grey-7" />
        </div>
        <div class="text-center">
          <QBtn color="primary" no-caps @click="onCancel()" id="cancelButtonId">Cancel</QBtn>
          <QBtn color="primary" no-caps @click="onCancel()" id="nextPageButtonId" style="display: none">Next Page</QBtn>
        </div>
      </QCard>
    </QDialog>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { QIcon, QList, QItem, QItemSection, QDialog, QCard, QSpinner, QBtn } from 'quasar';
import { CalculatorDialog } from '@/components/Calculator/CalculatorDialog';
import CalculatorButton from '@/components/Calculator/CalculatorButton';
import WetSignatureMixins from '@/mixins/WetSignatureMixins.js';
import ColoureMixins from '@/mixins/ColourMixins.js';
/**
 * This component represents common UI for displaying the status in the progress list
 */
export default {
  name: 'ProgressList',
  mixins: [WetSignatureMixins, ColoureMixins],
  props: {
    businessDetails: String,
    approvals: String,
    reviewSignContract: String
  },
  methods: {
    getProgressText: function (status) {
      switch (status) {
        case 'completed':
          return 'Completed';
        case 'progress':
          return 'In Progress';
        case 'pending':
          return 'Pending';
      }
    },
    openDialog: function () {
      this.$euiNotifications.emit({
        notification: CalculatorDialog,
        header: 'Identification verification and credit application are required as part of this step.',
        qCardStyle: {
          padding: '0',
          width: '400px',
          maxWidth: '80vw',
          minHeight: '300px'
        },
        headerStyle: 'font-size:16px',
        closeBtnStyle: {
          color: 'white'
        }
      });
    },
    onCancel: function () {
      this.showDocusign = false;
      this.docusignUrl = null;
    }
  },
  data: function () {
    return {
      showDocusign: false,
      docusignUrl: null
    };
  },
  computed: {
    ...mapState({
      scoreboard: (state) =>
        state.vehicleApplication?.vehicleApplication?.scoreboard ? state.vehicleApplication?.vehicleApplication?.scoreboard : null
    }),
    convertColourComputed() {
      return this.convertColour();
    },
    docusignStatus() {
      return this.scoreboard?.docusignStatus ? this.scoreboard?.docusignStatus : null;
    }
  },
  components: {
    QList,
    QItem,
    QItemSection,
    CalculatorButton,
    QDialog,
    QCard,
    QSpinner,
    QBtn,
    QIcon
  }
};
</script>

<style lang="sass">
.progress-lists
  .q-list
    font-size: 16px;
  .q-item
    display: flex
    flex-flow: row wrap
    vertical-align: middle
    align-items: center
    padding: 5px 0
    min-height: 42px
  .side-icon
    width: 32px
    height: 32px
    margin-right: 10px
  i
    color: var(--primary-color);

  .progress-item-btn.q-btn--outline, .progress-item-btn.q-btn, .progress-item-btn.q-btn:not(.done)
    height: 30px
    width: 100px
    .q-btn__wrapper
      padding: 0
      display: flex
      flex-flow: row wrap
      .q-btn__content
        padding: 0
        font-size: 12px
        height: 30px

  .progress-item-btn.q-btn--outline, .progress-item-btn.q-btn:not(.done)
    .q-btn__wrapper
      .q-btn__content
        display: flex
        flex-flow: row wrap
        justify-content: flex-start
        margin-left: 12px

        .q-icon
          position: absolute
          right: 5px
</style>
